export const AUTH_VERIFY_EMAIL = "AUTH_VERIFY_EMAIL";